import React, { useState } from 'react';
import Card from '../../components/common/Card';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { useAuth } from '../../hooks/useAuth';
import api from '../../services/api';

const SettingsView = () => {
  const { user } = useAuth();
  const [passwords, setPasswords] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [isUpdatingPassword, setIsUpdatingPassword] = useState(false);

  const handleChange = (field, value) => {
    setPasswords((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdatePassword = async () => {
    if (!passwords.new_password || !passwords.current_password) {
      return alert('New and Current passwords are required.');
    }
    if (passwords.new_password !== passwords.confirm_password) {
      return alert('New passwords do not match.');
    }

    setIsUpdatingPassword(true);
    try {
      await api.put(`/api/v1/users/${user.id}/password`, {
        current_password: passwords.current_password,
        new_password: passwords.new_password
      });
      alert('Password updated successfully!');
      setPasswords({ current_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      console.error('Failed to update password:', error);
      alert(error.response?.data?.detail || 'Failed to update password. Make sure your current password is correct.');
    } finally {
      setIsUpdatingPassword(false);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '32px' }}>
      <Card title="Profile" padding="24px">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '16px'
          }}
        >
          <Input
            label="Designation"
            placeholder="Not set — contact admin"
            value={user?.designation || ''}
            disabled
          />
        </div>
      </Card>
      </div>
      <Card title="Change Password" padding="24px">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '16px'
          }}
        >
          <Input
            label="Current Password"
            type="password"
            canPeekPassword
            placeholder="Enter current password"
            value={passwords.current_password}
            onChange={(e) => handleChange('current_password', e.target.value)}
          />
          <Input
            label="New Password"
            type="password"
            canPeekPassword
            placeholder="Enter new password"
            value={passwords.new_password}
            onChange={(e) => handleChange('new_password', e.target.value)}
          />
          <Input
            label="Confirm Password"
            type="password"
            canPeekPassword
            placeholder="Confirm new password"
            value={passwords.confirm_password}
            onChange={(e) => handleChange('confirm_password', e.target.value)}
          />
        </div>

        <div style={{ marginTop: '20px' }}>
          <Button 
            variant="primary" 
            onClick={handleUpdatePassword} 
            disabled={isUpdatingPassword}
          >
            {isUpdatingPassword ? 'Updating...' : 'Update Password'}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SettingsView;
